import { useState } from 'react';
import { useUnmount } from 'react-use';

export type StoredTabManagerState = {
  activeTab: string | null; //route
  tabs: string[]; //routes
};

export type TabManagerStorateAdapter = {
  getState: () => StoredTabManagerState;
  setState: (state: StoredTabManagerState) => void;
  notify(): void;
  subscribe(
    callback: (state: StoredTabManagerState | null) => void
  ): () => void;
  destroy(): void;
};

export type TabManagerStorageHook = (adapter: TabManagerStorateAdapter) => [
  StoredTabManagerState,
  {
    setState: (state: StoredTabManagerState) => void;
    sync: (state: StoredTabManagerState) => void;
  },
  adapter: TabManagerStorateAdapter
];

export const useTabManagerStorage: TabManagerStorageHook = (
  adapter: TabManagerStorateAdapter
) => {
  const [state, setState] = useState(adapter.getState());

  return [
    state,
    {
      setState: (state: StoredTabManagerState) => {
        adapter.setState(state);
        setState(state);
      },
      sync: (state: StoredTabManagerState) => {
        adapter.setState(state);
      },
    },
    adapter,
  ] as ReturnType<TabManagerStorageHook>;
};

export const useStorageAdapter = (adapter: TabManagerStorateAdapter) => {
  useUnmount(() => {
    return () => {
      adapter.destroy();
    };
  });
  return adapter;
};
